import flow from "lodash/fp/flow";
import get from "lodash/fp/get";
import getOr from "lodash/fp/getOr";
import map from "lodash/fp/map";
import values from "lodash/fp/values";
import sortBy from "lodash/fp/sortBy";

import selectUserChoiceValues from "./selectUserChoiceValues";
import selectSelectedProduct from "./selectSelectedProduct";
import { filterSkus } from "utils";

export function getMaterialID({ selectedProduct, userChoicesValues }) {
  return flow(
    getOr({}, ["skus"]),
    values,
    filterSkus(userChoicesValues),
    sortBy("order"),
    map(get("materialID")),
    (materialIDArray) =>
      materialIDArray.length > 1 ? materialIDArray : materialIDArray[0]
  )(selectedProduct);
}

export default function selectMaterialID(state) {
  const selectedProduct = selectSelectedProduct(state);
  const userChoicesValues = selectUserChoiceValues(state);

  return getMaterialID({
    selectedProduct,
    userChoicesValues: userChoicesValues,
  });
}
